import { RefreshCw } from 'lucide-react'
import { useSwUpdate } from '@/hooks/use-sw-update'
import { isDesktop } from '@/lib/platform'

export function UpdateBanner() {
  const { updateAvailable, applyUpdate } = useSwUpdate()

  // Desktop shows update indicator in the custom titlebar instead
  if (!updateAvailable || isDesktop()) return null

  return (
    <div className="flex items-center justify-between gap-3 bg-blue-600 px-4 py-2 text-sm text-white">
      <div className="flex items-center gap-2">
        <RefreshCw className="h-4 w-4" />
        <span>A new version of Ledger is available.</span>
      </div>
      <button
        type="button"
        onClick={applyUpdate}
        className="rounded bg-white/20 px-3 py-1 text-xs font-medium hover:bg-white/30 transition-colors"
      >
        Reload
      </button>
    </div>
  )
}
